/**
 * TrustGate Console - MetricRow Component
 * Key-value pair display for card details
 */

import React from 'react';
import { Badge } from './Badge';

interface MetricRowProps {
  label: string;
  value: string | number | null | undefined;
  badge?: boolean;
  mono?: boolean;
  copyable?: boolean;
  className?: string;
}

export const MetricRow: React.FC<MetricRowProps> = ({ 
  label, 
  value, 
  badge = false,
  mono = false,
  copyable = false,
  className = '' 
}) => {
  const displayValue = value ?? '—';
  
  const handleCopy = async () => {
    if (typeof displayValue === 'string' || typeof displayValue === 'number') {
      try {
        await navigator.clipboard.writeText(String(displayValue));
        // TODO: Show toast notification "Copied!"
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  };

  return (
    <div className={`flex justify-between items-center py-2 border-b border-white/5 last:border-0 ${className}`}>
      <span className="text-sm text-[#cbd5e1]">{label}</span>
      <div className="flex items-center gap-2">
        {badge && typeof displayValue === 'string' ? (
          <Badge status={displayValue} />
        ) : (
          <span className={`text-sm ${mono ? 'font-mono' : ''} text-[#f8fafc]`}>
            {displayValue}
          </span>
        )}
        {copyable && displayValue !== '—' && (
          <button
            onClick={handleCopy}
            className="text-[#cbd5e1] hover:text-[#00d4aa] transition-colors"
            title="Copy to clipboard"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
